
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Converter } from "@/containers/Converter";
import { Head } from "@/components/Head";

import { MagicianSection } from "@/sections/MagicianSection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { CustomersLogosSection } from "@/sections/CustomersLogosSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";

import { useTheme } from "@/hooks/useTheme";
import { CTASection } from "@/sections/CTASection";
import { FeaturesSection } from "@/sections/FeaturesSection";
import { PricingSection } from "@/sections/PricingSection";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";

const IndesignToSketch = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { isFeatureEnabled } = useFeatureFlags();

  return (
    <>
      <Head
        pageNamespace="page/IndesignToSketch"
        ogImage="/images/indesign2sketch-og-image.jpg"
      />

      <MagicianSection
        title={t("page/IndesignToSketch:title")}
        subtitle={t("page/IndesignToSketch:subtitle")}
        magicianLogoFile="indd"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter
          disabled={!isFeatureEnabled("DISPLAY_INDESIGN_CONVERTERS")}
        />
      </MagicianSection>

      <FeaturesSection
        features={[
          {
            iconType: "REFRESH",
            title: t("section/features:fastAndEfficient"),
            text: t("section/features:fastAndEfficientDescription"),
          },
          {
            iconType: "PIGGY",
            title: t("section/features:refund"),
            text: t("section/features:refundDescription"),
          },
          {
            iconType: "EYE",
            title: t("section/features:privacy"),
            text: t("section/features:privacyDescription"),
          },
        ]}
      />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/IndesignToSketch:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/indesign-to-sketch-converter-example.png",
          alt: "Indesign to Sketch converter example",
        }}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/IndesignToSketch:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/IndesignToSketch:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/indesign-to-sketch-converted-file-elements.png",
          alt: t("page/IndesignToSketch:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/IndesignToSketch:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/IndesignToSketch:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/IndesignToSketch:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/IndesignToSketch:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/IndesignToSketch:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "IMAGE-RED-ICON",
            title: t(
              "page/IndesignToSketch:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/IndesignToSketch:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <PricingSection />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsAll"),
          },
          {
            iconType: "CHECK-GREEN-ICON",
            text: t("section/conversion:badges.accuracy"),
          },
        ]}
        elements={{
          from: {
            iconType: "INDESIGN",
            image: "/images/indesign-preview.jpg",
            title: "Indesign Demo Preview",
          },
          to: {
            iconType: "SKETCH",
            image: "/images/indesign-sketch-preview.png",
            title: "Sketch Demo Preview",
          },
        }}
      />
      <CustomersLogosSection />

      <SelectFormatSection title={t("section/selectFormat:title")} />
      <CTASection
        title={t("section/cta:titles.indesignToSketchPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default IndesignToSketch;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/indesign-to-sketch',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  